import { createComponent } from 'react-fela'

import { breakpoints } from '../constants/theme'
import calculatePerBreakpoint from '../utils/calculatePerBreakpoint'

const Column = props => ({
  padding: props.noPadding ? 0 : '0 15px',
  maxWidth: '100%',
  alignSelf: 'stretch',
  height: props.height,
  order: props.order,
  ['@media (min-width: ' + breakpoints.min768 + 'px)']: {
    justifyContent: props.justifyContent || props.center && 'center',
    alignItems: props.alignItems || props.center && 'center'
  },
  ['@media (max-width: ' + (breakpoints.min768 - 1) + 'px)']: {
    flexDirection: props.rowOnSmall ? 'row' : 'column',
    padding: props.noPadding ? 0 : '0 10px',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  ['@media (max-width: ' + (breakpoints.min480 - 1) + 'px)']: {
    padding: 0
  },
  extend: [
    calculatePerBreakpoint(props.sizes, value => ({
      flexGrow: value !== undefined ? value : 1,
      flexBasis: (value !== undefined ? value : 1) * 30,
      padding: props.noPadding ? 0 : (value > 0 ? '0 15px' : 0)
    })),
    calculatePerBreakpoint(props.widths, value => ({
      maxWidth: value,
      width: value,
      padding: props.noPadding ? 0 : (value > 0 ? '0 15px' : 0)
    })), {
      condition: props.hideUntil,
      style: {
        ['@media (max-width: ' + (props.hideUntil - 1) + 'px)']: {
          display: 'none'
        }
      }
    }, {
      condition: props.onHover,
      style: { ':hover': props.onHover }
    } ]
})

export default createComponent(Column, 'div', [
  'onClick',
  'data-scroll-effect',
  'data-scroll-offset',
  'data-parallax-speed',
  'data-parallax-direction',
  'data-parallax-offset'
])



// WEBPACK FOOTER //
// ../components/Column.js